/**
 * This file is AUTO-GENERATED from the API.
 * Do not edit this file directly. Run `scripts/update_ability.sh` instead.
 *
 * Model: every subject implicitly supports CRUD (see TCrudAction in ability.ts).
 * Only the custom actions each subject additionally supports are listed here.
 */

export enum ESubjectsGenerated {
  // Address
  ADDRESS__ADDRESSAUTOCOMPLETE = "address.addressautocomplete",

  // Auditlog
  AUDITLOG__LOGENTRY = "auditlog.logentry",

  // Auth
  AUTH__GROUP = "auth.group",
  AUTH__PERMISSION = "auth.permission",

  // Authtoken
  AUTHTOKEN__TOKEN = "authtoken.token",
  AUTHTOKEN__TOKENPROXY = "authtoken.tokenproxy",

  // Billing
  BILLING__CHANGECOMPANYSUBSCRIPTION = "billing.changecompanysubscription",
  BILLING__CHANGEMSOSUBSCRIPTION = "billing.changemsosubscription",
  BILLING__COMPANYMSOBILLING = "billing.companymsobilling",
  BILLING__COMPANYSUBSCRIPTION = "billing.companysubscription",
  BILLING__COMPANYSUBSCRIPTIONINTERVAL = "billing.companysubscriptioninterval",
  BILLING__MSOSUBSCRIPTION = "billing.msosubscription",
  BILLING__MSOSUBSCRIPTIONINTERVAL = "billing.msosubscriptioninterval",

  // Contenttypes
  CONTENTTYPES__CONTENTTYPE = "contenttypes.contenttype",

  // Dental Monitoring
  DENTAL_MONITORING__EVENT = "dental_monitoring.event",

  // Django Celery Results
  DJANGO_CELERY_RESULTS__CHORDCOUNTER = "django_celery_results.chordcounter",
  DJANGO_CELERY_RESULTS__GROUPRESULT = "django_celery_results.groupresult",
  DJANGO_CELERY_RESULTS__TASKRESULT = "django_celery_results.taskresult",

  // Docusign
  DOCUSIGN__ENVELOPE = "docusign.envelope",

  // File
  FILE__FILESTORE = "file.filestore",
  FILE__FILESTOREANNOTATION = "file.filestoreannotation",
  FILE__MESSAGEFILE = "file.messagefile",
  FILE__PATIENTFILE = "file.patientfile",

  // Insurance Company
  INSURANCE_COMPANY__INSURANCECOMPANY = "insurance_company.insurancecompany",

  // Interfaces
  INTERFACES__PLATFORM = "interfaces.platform",

  // Invite
  INVITE__INVITE = "invite.invite",
  INVITE__RECIPIENT = "invite.recipient",
  INVITE__ROLE = "invite.role",
  INVITE__ROLESPECIALTY = "invite.rolespecialty",

  // Message
  MESSAGE__CHATROOM = "message.chatroom",
  MESSAGE__MESSAGE = "message.message",
  MESSAGE__NOTIFICATION = "message.notification",

  // Orbisqr
  ORBISQR__PRACTICEQRCODE = "orbisqr.practiceqrcode",
  ORBISQR__QRCODE = "orbisqr.qrcode",

  // Patient
  PATIENT__ALIGNERDELIVERYINSTRUCTIONS = "patient.alignerdeliveryinstructions",
  PATIENT__ALIGNERDELIVERYINSTRUCTIONSVISITRESULT = "patient.alignerdeliveryinstructionsvisitresult",
  PATIENT__CONSENT = "patient.consent",
  PATIENT__CTMCONTRACT = "patient.ctmcontract",
  PATIENT__FINALDEBONDVISITINSTRUCTIONS = "patient.finaldebondvisitinstructions",
  PATIENT__FINALDEBONDVISITINSTRUCTIONSVISITRESULT = "patient.finaldebondvisitinstructionsvisitresult",
  PATIENT__INSTRUCTIONFORNEXTVISIT = "patient.instructionfornextvisit",
  PATIENT__NEXTVISITINSTRUCTIONSV2 = "patient.nextvisitinstructionsv2",
  PATIENT__NEXTVISITINSTRUCTIONSV2VISITRESULT = "patient.nextvisitinstructionsv2visitresult",
  PATIENT__ORDERALIGNERS = "patient.orderaligners",
  PATIENT__ORTHONEEDSPATIENT = "patient.orthoneedspatient",
  PATIENT__ORTHOPROPOSEDPLAN = "patient.orthoproposedplan",
  PATIENT__ORTHOPROPOSEDPLANPRICINGOPTION = "patient.orthoproposedplanpricingoption",
  PATIENT__PATIENT = "patient.patient",
  PATIENT__PATIENTCOMPOSITEVIEW = "patient.patientcompositeview",
  PATIENT__PATIENTCONTACTEMAIL = "patient.patientcontactemail",
  PATIENT__PATIENTCONTACTPHONE = "patient.patientcontactphone",
  PATIENT__PATIENTFINANCINGPLAN = "patient.patientfinancingplan",
  PATIENT__PATIENTMONITORING = "patient.patientmonitoring",
  PATIENT__PATIENTRECORD = "patient.patientrecord",
  PATIENT__PATIENTSCAN = "patient.patientscan",
  PATIENT__SCANBOXHANDOVER = "patient.scanboxhandover",
  PATIENT__SCHEDULETCAPPOINTMENT = "patient.scheduletcappointment",

  // Practice
  PRACTICE__BANK = "practice.bank",
  PRACTICE__BRAND = "practice.brand",
  PRACTICE__COMPANY = "practice.company",
  PRACTICE__COMPANYINVOICE = "practice.companyinvoice",
  PRACTICE__COMPANYPAYOUT = "practice.companypayout",
  PRACTICE__CONNECTION = "practice.connection",
  PRACTICE__CONTRACT = "practice.contract",
  PRACTICE__DOCTORLICENCE = "practice.doctorlicence",
  PRACTICE__LEGALENTITY = "practice.legalentity",
  PRACTICE__MSO = "practice.mso",
  PRACTICE__MSOINVOICE = "practice.msoinvoice",
  PRACTICE__MSOPAYOUT = "practice.msopayout",
  PRACTICE__PRACTICE = "practice.practice",
  PRACTICE__PRACTICEAPIKEYSTORAGE = "practice.practiceapikeystorage",
  PRACTICE__PRACTICESTAFF = "practice.practicestaff",
  PRACTICE__PRACTICESTAFFAPIKEYSTORAGE = "practice.practicestaffapikeystorage",
  PRACTICE__PRICELIST = "practice.pricelist",

  // Product
  PRODUCT__COMPANYSUBSCRIPTIONPRODUCT = "product.companysubscriptionproduct",
  PRODUCT__MSOSUBSCRIPTIONPRODUCT = "product.msosubscriptionproduct",

  // Referral
  REFERRAL__REFERRAL = "referral.referral",
  REFERRAL__REFERRALCONSULTATION = "referral.referralconsultation",

  // Report
  REPORT__REPORT = "report.report",
  REPORT__REPORTDATA = "report.reportdata",

  // Scheduling
  SCHEDULING__CALENDAR = "scheduling.calendar",
  SCHEDULING__EVENT = "scheduling.event",

  // Sessions
  SESSIONS__SESSION = "sessions.session",

  // Sso
  SSO__SSOIDENTITY = "sso.ssoidentity",
  SSO__SSOPRACTICELINK = "sso.ssopracticelink",

  // Terms
  TERMS__TERMSDOCUMENT = "terms.termsdocument",
  TERMS__TERMSDOCUMENTVERSION = "terms.termsdocumentversion",

  // Token Blacklist
  TOKEN_BLACKLIST__BLACKLISTEDTOKEN = "token_blacklist.blacklistedtoken",
  TOKEN_BLACKLIST__OUTSTANDINGTOKEN = "token_blacklist.outstandingtoken",

  // Treatment Plan
  TREATMENT_PLAN__PATIENTTREATMENTJOB = "treatment_plan.patienttreatmentjob",
  TREATMENT_PLAN__PATIENTTREATMENTPLAN = "treatment_plan.patienttreatmentplan",
  TREATMENT_PLAN__TREATMENTJOB = "treatment_plan.treatmentjob",
  TREATMENT_PLAN__TREATMENTPLAN = "treatment_plan.treatmentplan",
  TREATMENT_PLAN__TREATMENTPLANBACKLOOP = "treatment_plan.treatmentplanbackloop",

  // User
  USER__LOGINHINTBADGE = "user.loginhintbadge",
  USER__ORBISGROUP = "user.orbisgroup",
  USER__ORBISUSER = "user.orbisuser",
}

export enum EActionsGenerated {
  // CRUD — implicitly available on every subject.
  CREATE = "create",
  READ = "read",
  UPDATE = "update",
  DELETE = "delete",

  // Custom actions.
  ACCEPT_REFERRAL = "accept_referral",
  ADD_BRAND_ADMIN = "add_brand_admin",
  ADD_COTREATMENT_CONTRACT = "add_cotreatment_contract",
  ADD_LEGALENTITY_ADMIN = "add_legalentity_admin",
  ADD_MEMBERS = "add_members",
  ADD_REFERRAL_CONTRACT = "add_referral_contract",
  ADD_REFERRAL_FREE_CONTRACT = "add_referral_free_contract",
  ALIGNER_DELIVERY_INSTRUCTIONS_VISIT_RESULT = "aligner_delivery_instructions_visit_result",
  BRAND_ME_EDIT = "brand_me_edit",
  BRAND_ME_VIEW = "brand_me_view",
  CAN_BE_ASSIGNED_AS_GP = "can_be_assigned_as_gp",
  CAN_BE_ASSIGNED_AS_ORTHODONTIST = "can_be_assigned_as_orthodontist",
  CAN_BE_ASSIGNED_AS_TREATMENT_COORDINATOR = "can_be_assigned_as_treatment_coordinator",
  CAN_CONNECT_ITERO = "can_connect_itero",
  CAN_CREATE_USER_SETTINGS = "can_create_user_settings",
  CAN_ENTER_MEDICAL_LICENSE_INFO = "can_enter_medical_license_info",
  CAN_OWN_GP_PRACTICE = "can_own_gp_practice",
  CAN_OWN_ORTHO_PRACTICE = "can_own_ortho_practice",
  CAN_VIEW_USER_SETTINGS = "can_view_user_settings",
  CHANGE_BRAND_ADMIN = "change_brand_admin",
  CHANGE_COMPANY_ADMIN = "change_company_admin",
  CHANGE_CONTRACT_ADMIN = "change_contract_admin",
  CHANGE_LEGALENTITY_ADMIN = "change_legalentity_admin",
  CHANGE_MSO_ADMIN = "change_mso_admin",
  CHANGE_PATIENT_ADMIN = "change_patient_admin",
  CHANGE_PLATFORM_ADMIN = "change_platform_admin",
  CHANGE_PRACTICE_ADMIN = "change_practice_admin",
  CHANGE_PRACTICESTAFF_ME = "change_practicestaff_me",
  COMPANY_ME_EDIT = "company_me_edit",
  COMPANY_ME_VIEW = "company_me_view",
  DELETE_BRAND_ADMIN = "delete_brand_admin",
  DELETE_COMPANY_ADMIN = "delete_company_admin",
  DELETE_CONTRACT_ADMIN = "delete_contract_admin",
  DELETE_LEGALENTITY_ADMIN = "delete_legalentity_admin",
  DELETE_MSO_ADMIN = "delete_mso_admin",
  DELETE_PATIENT_ADMIN = "delete_patient_admin",
  DELETE_PLATFORM_ADMIN = "delete_platform_admin",
  DELETE_PRACTICE_ADMIN = "delete_practice_admin",
  DIRECT = "direct",
  DOWNLOAD_PATIENT_EXPORT = "download_patient_export",
  EXPORT_TREATMENT_PLAN = "export_treatment_plan",
  FINAL_DEBOND_VISIT_INSTRUCTIONS_VISIT_RESULT = "final_debond_visit_instructions_visit_result",
  GROUP = "group",
  IMPERSONATE = "impersonate",
  IMPORT_TREATMENT_PLAN = "import_treatment_plan",
  JOB_IS_GP = "job:is_gp",
  JOB_IS_GP_OFFICE_MANAGER = "job:is_gp_office_manager",
  JOB_IS_GP_PRACTICE_ASSISTANT = "job:is_gp_practice_assistant",
  JOB_IS_HYGIENIST = "job:is_hygienist",
  JOB_IS_ORTHO_OFFICE_MANAGER = "job:is_ortho_office_manager",
  JOB_IS_ORTHO_PRACTICE_ASSISTANT = "job:is_ortho_practice_assistant",
  JOB_IS_ORTHODONTIST = "job:is_orthodontist",
  JOB_IS_TREATMENT_COORDINATOR = "job:is_treatment_coordinator",
  LEAVE = "leave",
  LEGALENTITY_ME_EDIT = "legalentity_me_edit",
  LEGALENTITY_ME_VIEW = "legalentity_me_view",
  MANAGE_ADMINISTRATION = "manage_administration",
  MANAGE_BILLING = "manage_billing",
  MANAGE_CHANGE_COMPANY_SUBSCRIPTION_ADMIN = "manage_change_company_subscription_admin",
  MANAGE_CHANGE_MSO_SUBSCRIPTION_ADMIN = "manage_change_mso_subscription_admin",
  MANAGE_COMPANY_MSO_BILLING_ADMIN = "manage_company_mso_billing_admin",
  MANAGE_COMPANY_SUBSCRIPTION_ADMIN = "manage_company_subscription_admin",
  MANAGE_CONNECTION = "manage_connection",
  MANAGE_CONNECTION_ADMIN = "manage_connection_admin",
  MANAGE_CONSULTATION = "manage_consultation",
  MANAGE_MSO_BILLING = "manage_mso_billing",
  MANAGE_MSO_SUBSCRIPTION = "manage_mso_subscription",
  MANAGE_MSO_SUBSCRIPTION_ADMIN = "manage_mso_subscription_admin",
  MANAGE_ORBISGROUP = "manage_orbisgroup",
  MANAGE_ORBISGROUP_PROTECTED = "manage_orbisgroup_protected",
  MANAGE_PLATFORM_CONTROL = "manage_platform_control",
  MARK_READ = "mark_read",
  MSO_ME_EDIT = "mso_me_edit",
  MSO_ME_VIEW = "mso_me_view",
  MUST_HAVE_GP_COMPANY_ASSIGNED = "must_have_gp_company_assigned",
  MUST_HAVE_ORTHO_COMPANY_ASSIGNED = "must_have_ortho_company_assigned",
  MUTE = "mute",
  NEXT_VISIT_INSTRUCTIONS_V2_VISIT_RESULT = "next_visit_instructions_v2_visit_result",
  PMS_SEARCH = "pms_search",
  PRACTICE_ME_EDIT = "practice_me_edit",
  PRACTICE_ME_VIEW = "practice_me_view",
  REJECT_REFERRAL = "reject_referral",
  RESEND = "resend",
  RESPOND = "respond",
  REVOKE_INVITE = "revoke_invite",
  REVOKE_RECIPIENT = "revoke_recipient",
  SHOW_LOGINHINTBADGE = "show_loginhintbadge",
  START_COMPANY_SUBSCRIPTION_ADMIN = "start_company_subscription_admin",
  START_MSO_SUBSCRIPTION_ADMIN = "start_mso_subscription_admin",
  STOP_IMPERSONATING = "stop_impersonating",
  UNMUTE = "unmute",
  UNREAD = "unread",
  UPDATE_REFERRAL_STATUS = "update_referral_status",
  VIEW_BRAND_ADMIN = "view_brand_admin",
  VIEW_COMPANY_ADMIN = "view_company_admin",
  VIEW_COMPANY_BILLING_ADMIN = "view_company_billing_admin",
  VIEW_COMPANYCONTRACTLIST = "view_companycontractlist",
  VIEW_COMPANYINVOICE_ADMIN = "view_companyinvoice_admin",
  VIEW_COMPANYPAYOUT_ADMIN = "view_companypayout_admin",
  VIEW_CONTRACT_ADMIN = "view_contract_admin",
  VIEW_COOPERATE_PARTIES = "view_cooperate_parties",
  VIEW_COTREATMENT_CONTRACT = "view_cotreatment_contract",
  VIEW_LEGALENTITY_ADMIN = "view_legalentity_admin",
  VIEW_MSO_ADMIN = "view_mso_admin",
  VIEW_MSO_BILLING_ADMIN = "view_mso_billing_admin",
  VIEW_MSOINVOICE_ADMIN = "view_msoinvoice_admin",
  VIEW_MSOPAYOUT_ADMIN = "view_msopayout_admin",
  VIEW_ORBISGROUP_SIMPLE = "view_orbisgroup_simple",
  VIEW_PATIENT_ADMIN = "view_patient_admin",
  VIEW_PLATFORM_ADMIN = "view_platform_admin",
  VIEW_PRACTICE_ADMIN = "view_practice_admin",
  VIEW_PRACTICESTAFF_ME = "view_practicestaff_me",
  VIEW_REFERRAL_CONTRACT = "view_referral_contract",
  VIEW_REFERRAL_FREE_CONTRACT = "view_referral_free_contract",
}

/**
 * Custom actions available per subject. CRUD is implicit for every subject and
 * intentionally omitted. Subjects with no custom actions are absent.
 */
export const CUSTOM_ACTIONS_BY_SUBJECT = {
  [ESubjectsGenerated.BILLING__CHANGECOMPANYSUBSCRIPTION]: [
    EActionsGenerated.MANAGE_CHANGE_COMPANY_SUBSCRIPTION_ADMIN,
  ],
  [ESubjectsGenerated.BILLING__CHANGEMSOSUBSCRIPTION]: [
    EActionsGenerated.MANAGE_CHANGE_MSO_SUBSCRIPTION_ADMIN,
  ],
  [ESubjectsGenerated.BILLING__COMPANYMSOBILLING]: [
    EActionsGenerated.MANAGE_COMPANY_MSO_BILLING_ADMIN,
  ],
  [ESubjectsGenerated.BILLING__COMPANYSUBSCRIPTION]: [
    EActionsGenerated.MANAGE_COMPANY_SUBSCRIPTION_ADMIN,
    EActionsGenerated.START_COMPANY_SUBSCRIPTION_ADMIN,
  ],
  [ESubjectsGenerated.BILLING__MSOSUBSCRIPTION]: [
    EActionsGenerated.MANAGE_MSO_SUBSCRIPTION,
    EActionsGenerated.MANAGE_MSO_SUBSCRIPTION_ADMIN,
    EActionsGenerated.START_MSO_SUBSCRIPTION_ADMIN,
  ],
  [ESubjectsGenerated.INTERFACES__PLATFORM]: [
    EActionsGenerated.CHANGE_PLATFORM_ADMIN,
    EActionsGenerated.DELETE_PLATFORM_ADMIN,
    EActionsGenerated.VIEW_PLATFORM_ADMIN,
  ],
  [ESubjectsGenerated.INVITE__INVITE]: [EActionsGenerated.REVOKE_INVITE],
  [ESubjectsGenerated.INVITE__RECIPIENT]: [
    EActionsGenerated.RESEND,
    EActionsGenerated.RESPOND,
    EActionsGenerated.REVOKE_RECIPIENT,
  ],
  [ESubjectsGenerated.MESSAGE__CHATROOM]: [
    EActionsGenerated.ADD_MEMBERS,
    EActionsGenerated.DIRECT,
    EActionsGenerated.GROUP,
    EActionsGenerated.LEAVE,
    EActionsGenerated.MUTE,
    EActionsGenerated.UNMUTE,
  ],
  [ESubjectsGenerated.MESSAGE__MESSAGE]: [EActionsGenerated.MARK_READ, EActionsGenerated.UNREAD],
  [ESubjectsGenerated.PATIENT__ALIGNERDELIVERYINSTRUCTIONSVISITRESULT]: [
    EActionsGenerated.ALIGNER_DELIVERY_INSTRUCTIONS_VISIT_RESULT,
  ],
  [ESubjectsGenerated.PATIENT__FINALDEBONDVISITINSTRUCTIONSVISITRESULT]: [
    EActionsGenerated.FINAL_DEBOND_VISIT_INSTRUCTIONS_VISIT_RESULT,
  ],
  [ESubjectsGenerated.PATIENT__NEXTVISITINSTRUCTIONSV2VISITRESULT]: [
    EActionsGenerated.NEXT_VISIT_INSTRUCTIONS_V2_VISIT_RESULT,
  ],
  [ESubjectsGenerated.PATIENT__PATIENT]: [
    EActionsGenerated.CHANGE_PATIENT_ADMIN,
    EActionsGenerated.DELETE_PATIENT_ADMIN,
    EActionsGenerated.PMS_SEARCH,
    EActionsGenerated.VIEW_PATIENT_ADMIN,
  ],
  [ESubjectsGenerated.PRACTICE__BRAND]: [
    EActionsGenerated.ADD_BRAND_ADMIN,
    EActionsGenerated.BRAND_ME_EDIT,
    EActionsGenerated.BRAND_ME_VIEW,
    EActionsGenerated.CHANGE_BRAND_ADMIN,
    EActionsGenerated.DELETE_BRAND_ADMIN,
    EActionsGenerated.VIEW_BRAND_ADMIN,
  ],
  [ESubjectsGenerated.PRACTICE__COMPANY]: [
    EActionsGenerated.CHANGE_COMPANY_ADMIN,
    EActionsGenerated.COMPANY_ME_EDIT,
    EActionsGenerated.COMPANY_ME_VIEW,
    EActionsGenerated.DELETE_COMPANY_ADMIN,
    EActionsGenerated.MANAGE_BILLING,
    EActionsGenerated.VIEW_COMPANYCONTRACTLIST,
    EActionsGenerated.VIEW_COMPANY_ADMIN,
    EActionsGenerated.VIEW_COMPANY_BILLING_ADMIN,
  ],
  [ESubjectsGenerated.PRACTICE__COMPANYINVOICE]: [EActionsGenerated.VIEW_COMPANYINVOICE_ADMIN],
  [ESubjectsGenerated.PRACTICE__COMPANYPAYOUT]: [EActionsGenerated.VIEW_COMPANYPAYOUT_ADMIN],
  [ESubjectsGenerated.PRACTICE__CONNECTION]: [
    EActionsGenerated.MANAGE_CONNECTION,
    EActionsGenerated.MANAGE_CONNECTION_ADMIN,
  ],
  [ESubjectsGenerated.PRACTICE__CONTRACT]: [
    EActionsGenerated.ADD_COTREATMENT_CONTRACT,
    EActionsGenerated.ADD_REFERRAL_CONTRACT,
    EActionsGenerated.ADD_REFERRAL_FREE_CONTRACT,
    EActionsGenerated.CHANGE_CONTRACT_ADMIN,
    EActionsGenerated.DELETE_CONTRACT_ADMIN,
    EActionsGenerated.VIEW_CONTRACT_ADMIN,
    EActionsGenerated.VIEW_COTREATMENT_CONTRACT,
    EActionsGenerated.VIEW_REFERRAL_CONTRACT,
    EActionsGenerated.VIEW_REFERRAL_FREE_CONTRACT,
  ],
  [ESubjectsGenerated.PRACTICE__LEGALENTITY]: [
    EActionsGenerated.ADD_LEGALENTITY_ADMIN,
    EActionsGenerated.CHANGE_LEGALENTITY_ADMIN,
    EActionsGenerated.DELETE_LEGALENTITY_ADMIN,
    EActionsGenerated.LEGALENTITY_ME_EDIT,
    EActionsGenerated.LEGALENTITY_ME_VIEW,
    EActionsGenerated.VIEW_LEGALENTITY_ADMIN,
  ],
  [ESubjectsGenerated.PRACTICE__MSO]: [
    EActionsGenerated.CHANGE_MSO_ADMIN,
    EActionsGenerated.DELETE_MSO_ADMIN,
    EActionsGenerated.MANAGE_MSO_BILLING,
    EActionsGenerated.MSO_ME_EDIT,
    EActionsGenerated.MSO_ME_VIEW,
    EActionsGenerated.VIEW_MSO_ADMIN,
    EActionsGenerated.VIEW_MSO_BILLING_ADMIN,
  ],
  [ESubjectsGenerated.PRACTICE__MSOINVOICE]: [EActionsGenerated.VIEW_MSOINVOICE_ADMIN],
  [ESubjectsGenerated.PRACTICE__MSOPAYOUT]: [EActionsGenerated.VIEW_MSOPAYOUT_ADMIN],
  [ESubjectsGenerated.PRACTICE__PRACTICE]: [
    EActionsGenerated.CHANGE_PRACTICE_ADMIN,
    EActionsGenerated.DELETE_PRACTICE_ADMIN,
    EActionsGenerated.PRACTICE_ME_EDIT,
    EActionsGenerated.PRACTICE_ME_VIEW,
    EActionsGenerated.VIEW_PRACTICE_ADMIN,
  ],
  [ESubjectsGenerated.PRACTICE__PRACTICESTAFF]: [
    EActionsGenerated.CAN_BE_ASSIGNED_AS_GP,
    EActionsGenerated.CAN_BE_ASSIGNED_AS_ORTHODONTIST,
    EActionsGenerated.CAN_BE_ASSIGNED_AS_TREATMENT_COORDINATOR,
    EActionsGenerated.CAN_CREATE_USER_SETTINGS,
    EActionsGenerated.CAN_ENTER_MEDICAL_LICENSE_INFO,
    EActionsGenerated.CAN_OWN_GP_PRACTICE,
    EActionsGenerated.CAN_OWN_ORTHO_PRACTICE,
    EActionsGenerated.CAN_VIEW_USER_SETTINGS,
    EActionsGenerated.CHANGE_PRACTICESTAFF_ME,
    EActionsGenerated.IMPERSONATE,
    EActionsGenerated.MANAGE_ADMINISTRATION,
    EActionsGenerated.MANAGE_PLATFORM_CONTROL,
    EActionsGenerated.MUST_HAVE_GP_COMPANY_ASSIGNED,
    EActionsGenerated.MUST_HAVE_ORTHO_COMPANY_ASSIGNED,
    EActionsGenerated.STOP_IMPERSONATING,
    EActionsGenerated.VIEW_PRACTICESTAFF_ME,
  ],
  [ESubjectsGenerated.PRACTICE__PRACTICESTAFFAPIKEYSTORAGE]: [EActionsGenerated.CAN_CONNECT_ITERO],
  [ESubjectsGenerated.REFERRAL__REFERRAL]: [
    EActionsGenerated.ACCEPT_REFERRAL,
    EActionsGenerated.REJECT_REFERRAL,
    EActionsGenerated.UPDATE_REFERRAL_STATUS,
  ],
  [ESubjectsGenerated.REFERRAL__REFERRALCONSULTATION]: [EActionsGenerated.MANAGE_CONSULTATION],
  [ESubjectsGenerated.REPORT__REPORTDATA]: [EActionsGenerated.DOWNLOAD_PATIENT_EXPORT],
  [ESubjectsGenerated.TREATMENT_PLAN__PATIENTTREATMENTPLAN]: [
    EActionsGenerated.VIEW_COOPERATE_PARTIES,
  ],
  [ESubjectsGenerated.TREATMENT_PLAN__TREATMENTPLAN]: [
    EActionsGenerated.EXPORT_TREATMENT_PLAN,
    EActionsGenerated.IMPORT_TREATMENT_PLAN,
    EActionsGenerated.JOB_IS_GP,
    EActionsGenerated.JOB_IS_GP_OFFICE_MANAGER,
    EActionsGenerated.JOB_IS_GP_PRACTICE_ASSISTANT,
    EActionsGenerated.JOB_IS_HYGIENIST,
    EActionsGenerated.JOB_IS_ORTHODONTIST,
    EActionsGenerated.JOB_IS_ORTHO_OFFICE_MANAGER,
    EActionsGenerated.JOB_IS_ORTHO_PRACTICE_ASSISTANT,
    EActionsGenerated.JOB_IS_TREATMENT_COORDINATOR,
  ],
  [ESubjectsGenerated.USER__LOGINHINTBADGE]: [EActionsGenerated.SHOW_LOGINHINTBADGE],
  [ESubjectsGenerated.USER__ORBISGROUP]: [
    EActionsGenerated.MANAGE_ORBISGROUP,
    EActionsGenerated.MANAGE_ORBISGROUP_PROTECTED,
    EActionsGenerated.VIEW_ORBISGROUP_SIMPLE,
  ],
} as const;
